import { render } from "./App.vue?vue&type=template&id=0947052e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0947052e&lang=scss"

import exportComponent from "C:\\Users\\Лейла\\Desktop\\azbcrm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__